import { ComponentProps, forwardRef } from 'react';

import { Button } from '@project44/manifest-ui-deprecated';

const baseStyles = {
  focus: {
    outline: '1px solid transparent',
    boxShadow: '#a3ace6 0px 0px 0px 2px',
    borderColor: 'white',
  },
};

const styles = {
  button: {
    backgroundImage: 'none',
    bgColor: '#16158D',
    border: ' 1px solid',
    borderColor: '#C7CCF0',
    color: 'white',
    '&:hover': {
      bgColor: '#232B9C',
      borderColor: 'white',
    },
    '&:focus': baseStyles.focus,
    '&:focus::after': { outline: 0, boxShadow: 'none' },
  },
  buttonActive: {
    backgroundImage: 'none',
    bgColor: '#3142C8',
    borderColor: 'white',
    color: 'white',
  },
};

interface HeaderButtonProps
  extends Omit<ComponentProps<typeof Button>, 'variant'> {
  hasModalActive?: boolean;
}

const HeaderButton = forwardRef<HTMLButtonElement, HeaderButtonProps>(
  ({ sx, hasModalActive = false, ...props }, ref) => {
    return (
      <Button
        ref={ref}
        sx={{
          ...styles.button,
          ...(hasModalActive && styles.buttonActive),
          ...sx,
        }}
        {...props}
      />
    );
  },
);

export default HeaderButton;
